export var ja = {
    required: '必須',
    deprecated: '非推奨',
    deprecated_and_sunset_on: 'この操作は非推奨であり、${1}に廃止されます。',
    stability_experimental: '実験的',
    stability_alpha: 'アルファ',
    stability_beta: 'ベータ',
    copy_to_clipboard: 'クリップボードにコピー',
    copied: 'コピー済み',
    no_content: 'コンテンツなし',
    unresolved_reference: '未解決の参照',
    circular_reference: '循環参照',
    read_only: '読み取り専用',
    write_only: '書き込み専用',
    optional: 'オプション',
    min: '最小',
    max: '最大',
    nullable: 'ヌル許容',
    body: '本文',
    payload: 'ペイロード',
    headers: 'ヘッダー',
    authorizations: '認可',
    responses: 'レスポンス',
    path_parameters: 'パスパラメータ',
    query_parameters: 'クエリパラメータ',
    header_parameters: 'ヘッダーパラメータ',
    attributes: '属性',
    test_it: 'テストする',
    information: '情報',
    success: '成功',
    redirect: 'リダイレクト',
    error: 'エラー',
    show: '表示',
    hide: '非表示',
    available_items: '利用可能なアイテム',
    child_attributes: '子属性',
};
